import React from "react";
import { Dialog } from "@headlessui/react";
import CloseIconButton from "../../../../components/CloseIconButton";
import { QrCodeIcon } from "@heroicons/react/24/solid";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import { officeShowState } from "../../OfficeSettings/atoms/atoms";
import { useRecoilState } from "recoil";

interface ProducerCodeViewProp {
  showFullView: any;
  closeFullView: () => void;
  producerCodeId: any;
  data: any;
  handleEditButton: any;
}
export const ProducerCodeView: React.FC<ProducerCodeViewProp> = ({
  showFullView,
  closeFullView,
  children,
  producerCodeId,
  data,
  handleEditButton,
}) => {
  const [isShow, setShowState] = useRecoilState(officeShowState);

  return (
    <>
      <Dialog open={showFullView} onClose={() => { }} className="relative z-40">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Dialog.Panel className="relative mx-auto p-4 w-4/5 rounded bg-white border-primary border-l-4">
              <CloseIconButton onClick={() => closeFullView()} />
              <div className="flex justify-between mx-2 pb-2 border-secondary border-b-2">
                <div className="flex items-center space-x-2">
                  <div>
                    <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-row mr-auto items-center space-x-2 text-sm ">
                    <div className="font-medium">
                      {producerCodeId?.masterCarrierID === 20
                        ? "Princeton Code ID:"
                        : "Producer Code ID:"}{" "}
                    </div>
                    <div className="">{producerCodeId?.producerCode}</div>
                  </div>
                </div>
                <div>
                  {isShow ? (
                    <EditOutlineButton
                      onClick={() => {
                        handleEditButton(data);
                      }}
                      buttonText="Edit"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="">{children}</div>
            </Dialog.Panel>
            <div className="text-xs max-h-fit"></div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
